import { combineReducers, Reducer } from 'redux'
import { configureStore, isImmutableDefault, isPlain } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import { mainAppReducer } from './mainAppReducer'
import { authReducer } from './authReducer'
import { eventReducer } from './eventReducer'
import CapacitorStorage from 'Utils/CapacitorStorage';
import { repertoireReducer, RepertoireReducer } from './repertoireReducer';
import { LessonReducer, lessonReducer, LessonState } from './lessonReducer'
import { debugReducer } from './debugReducer';
import { isImmutable } from 'immutable'
import createSagaMiddleware from 'redux-saga'
import rootSaga from 'Sagas'
import { isCapacitorNative } from 'Utils/Constants'
import { tutorialReducer } from './tutorialReducer'
    import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { actionTypes } from 'Types'
import { EventActionTypes } from 'Types/EventTypes'

const authPersistConfig = {
  key: "authPersistance",
  storage: CapacitorStorage,
  whitelist: [
    "tempSignUpPass", // used to log in after sign up verification
    "isAuthenticated", // will be overridden, but prevents a load screen
    "isLoading",
    "oauthPending"
  ],
  stateReconciler: hardSet,
};

const mainAppPersistConfig = {
  key: "mainAppPersistance",
  storage: CapacitorStorage,
  stateReconciler: hardSet,
};
const repertoirePersistConfig = {
  key: "repertoirePersistance",
  storage: CapacitorStorage,
  stateReconciler: hardSet,
};

const lessonPersistConfig = {
  key: "lessonPersistance",
  storage: CapacitorStorage,
  blacklist: [
    "currentUserLevelData", // can't have lsson.currentUserLevelData?.play_session?.id set on login or will cause double render
  ],
  stateReconciler: hardSet,
};

const tutorialPersistConfig = {
  key: "tutorialPersistance",
  storage: CapacitorStorage,
  stateReconciler: hardSet,
};

export const authPersistedReducer = persistReducer(
  authPersistConfig,
  authReducer,
);


const createRootReducer = () => combineReducers({
  authReducer: persistReducer(
    authPersistConfig,
    authReducer,
  ),
  mainAppReducer: persistReducer(
    mainAppPersistConfig,
    mainAppReducer
  ),
  eventReducer,
  repertoireReducer: persistReducer(
    repertoirePersistConfig,
    repertoireReducer
  ),
  lessonReducer: persistReducer(
    lessonPersistConfig,
    lessonReducer
  ),
  tutorialReducer: persistReducer(
    tutorialPersistConfig,
    tutorialReducer
  ),
  debugReducer,
});

const sagaMiddleware = createSagaMiddleware();


export const store = configureStore({
  reducer: createRootReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // hackity hack hack https://github.com/reduxjs/redux-toolkit/discussions/3539
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, actionTypes.SET_LAST_SHOWN_SURVEY, EventActionTypes.DISPATCH_EVENTS_SUCCESS],
        isSerializable: (value: any) => isImmutable(value) || isPlain(value) || value instanceof Date,
        getEntries: (value: any) =>
          isImmutable(value)
            ? value.entries()
            : Object.entries(value) as any,
      },
      thunk: true 
    }).concat(sagaMiddleware),
  devTools: process.env.REACT_APP_NODE_ENV !== 'prod',
});

sagaMiddleware.run(rootSaga);


export default createRootReducer;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
